import classNames from "classnames";
import LoadingBar from "../../../shared/LoadingBar";
import { gql } from "@apollo/client";
import { AutopilotSessionWebhookExportModalLoading_ExportToWebhookTransactionStatusFragment } from "../../../../__generated__/graphql";
import AutopilotSessionWebhookExportModalHeader from "./AutopilotSessionWebhookExportModalHeader";

export const AutopilotSessionWebhookExportModalLoading_ExportToWebhookTransactionStatus = gql`
  fragment AutopilotSessionWebhookExportModalLoading_ExportToWebhookTransactionStatus on ExportToWebhookTransactionStatusResponse {
    totalCount
    sentCount
  }
`;

interface IAutopilotSessionWebhookExportModalLoadingProps {
  exportToWebhookTransactionStatus:
    | AutopilotSessionWebhookExportModalLoading_ExportToWebhookTransactionStatusFragment
    | undefined;
  onClose: () => void;
}

const AutopilotSessionWebhookExportModalLoading = ({
  exportToWebhookTransactionStatus,
  onClose,
}: IAutopilotSessionWebhookExportModalLoadingProps) => {
  return (
    <>
      <AutopilotSessionWebhookExportModalHeader
        title="Webhook export in progress"
        onClose={onClose}
      />
      <div className={classNames("sm:flex", "sm:items-start")}>
        <div
          className={classNames("mt-3", "sm:mt-0", "sm:text-left", "w-full")}
        >
          <div
            className={classNames(
              "text-center",
              "py-8",
              "max-w-full",
              "px-4",
              "overflow-hidden",
            )}
          >
            <div
              className={classNames(
                "w-full",
                "max-w-sm",
                "mx-auto",
                "overflow-hidden",
              )}
            >
              <LoadingBar
                customFillPercentage={
                  exportToWebhookTransactionStatus?.totalCount
                    ? exportToWebhookTransactionStatus.sentCount /
                      exportToWebhookTransactionStatus.totalCount
                    : 0
                }
              />
            </div>
            <p className={classNames("mt-4", "text-sm", "text-gray-600")}>
              Webhook push in progress. Sit tight while we send your data.
            </p>

            {exportToWebhookTransactionStatus && (
              <div className={classNames("mt-6")}>
                <p className={classNames("text-sm", "text-gray-600")}>
                  {exportToWebhookTransactionStatus.sentCount} of{" "}
                  {exportToWebhookTransactionStatus.totalCount} contacts sent
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AutopilotSessionWebhookExportModalLoading;
